module.exports = __webpack_public_path__ + "img/ic_publicity_detail4_3.e9dd8e35.jpeg";